import React from "react";
import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";

export default function ErrorState({ title = "Error", message = "Something went wrong.", onRetry, actions }) {
  return (
    <Box sx={{ width: "100%", py: 4, display: "flex", justifyContent: "center" }}>
      <Alert severity="error" variant="outlined" sx={{ maxWidth: 640, width: "100%" }}>
        <AlertTitle>{title}</AlertTitle>
        <Typography variant="body2" sx={{ mb: actions || onRetry ? 1 : 0 }}>{message}</Typography>
        {(actions || onRetry) && (
          <Stack direction="row" spacing={1} mt={1}>
            {onRetry && (
              <Button variant="outlined" color="error" size="small" onClick={onRetry}>
                Retry
              </Button>
            )}
            {actions}
          </Stack>
        )}
      </Alert>
    </Box>
  );
}
